export function cluthaLocations() {
    $('#Place_Names a').on('mouseenter', function(e) {
        e.preventDefault(); // Prevent the default action of the <a> tag

        let backgroundImage = $('.locations-background-image');
        let titleWrapper = $('#destinationTitle');
        let contentWrapper = $('#destinationContent');
        let linkWrapper = $('#destinationLink');

        let newImage = $(this).attr('data-image');
        let title = $(this).attr('data-title');
        let content = $(this).attr('data-content');
        let link = $(this).attr('data-link');

        titleWrapper.html(title);
        contentWrapper.html(content);
        console.log(link);
        let newlink = '<a href="' + link + '" class="btn btn-primary">Find Out More</a>';
        linkWrapper.html(newlink);

            backgroundImage.attr('src', newImage);
    });
}
